import { render, staticRenderFns } from "./Notificari.vue?vue&type=template&id=8ac5e23e"
import script from "./Notificari.vue?vue&type=script&lang=js"
export * from "./Notificari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports